"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var location_1 = require("~/util/location");
var LINK_PATH = {
    COMPANY: "/company",
    MAPS_LOCATIONS: "/maps/location",
    MAPS: "/maps",
    COMPANY_SEARCH: "/company_search"
};
var defaultListItem = function (path, label) { return react_1.default.createElement("a", { href: path, className: "sharedHeaderNaviItemCompany-Children_ListItemLabel" }, label); };
var listItems = [
    defaultListItem(LINK_PATH.COMPANY, '一覧から探す'),
    react_1.default.createElement("span", { key: LINK_PATH.MAPS_LOCATIONS, onClick: location_1.moveToMapsLocation, className: "sharedHeaderNaviItemCompany-Children_ListItemLabel" }, "\u73FE\u5728\u5730\u304B\u3089\u63A2\u3059"),
    defaultListItem(LINK_PATH.MAPS, '地域から探す'),
    defaultListItem(LINK_PATH.COMPANY_SEARCH, '検索する')
];
var NaviItemCompany = function () {
    var _a = react_1.default.useState(true), isClosed = _a[0], setIsClosed = _a[1];
    var childrenClassName = (0, classnames_1.default)("sharedHeaderNaviItemCompany-Children", { "sharedHeaderNaviItemCompany-Children-closed": isClosed });
    return (react_1.default.createElement("li", { onMouseEnter: function () { return setIsClosed(false); }, onMouseLeave: function () { return setIsClosed(true); }, className: "jirafficon jirafficon-shop siteHeader-GuideIcon sharedHeaderNaviItemCompany-Root" },
        react_1.default.createElement("span", { className: "siteHeader-GuideText sharedHeaderNaviItemCompany-Root_Label" },
            "\u8CB7\u53D6\u696D\u8005\u3092\u63A2\u3059",
            react_1.default.createElement("i", { className: "sharedHeaderNaviItemCompany-Root_DownAllow fa fa-chevron-down" })),
        react_1.default.createElement("div", { className: childrenClassName }, listItems.map(function (item, idx) { return (react_1.default.createElement("div", { key: idx, className: "sharedHeaderNaviItemCompany-Children_ListItem" },
            item,
            react_1.default.createElement("i", { className: "fa fa-chevron-right sharedHeaderNaviItemCompany-Children_ListItemIcon" }))); }))));
};
exports.default = NaviItemCompany;
